import api from ".";
import { integrationEndpoints } from "./endpoints/integrations.endpoints";

export const integrationApis = {
  getSdmProjects: async () => {
    const res = await api.get(integrationEndpoints.sdmProjects);
    return res.data;
  },

  importFromSdm: async (reportId, payload) => {
    const res = await api.post(integrationEndpoints.sdmImport(reportId), payload);
    return res.data;
  },
};
